<wiz-hgroup #actionContainer width="100%" height="100%" verticalAlign="center" style="padding: 3px">
  <wiz-checkbox
    #cbPinned
    *ngIf="showPinned()"
    [wizShowLabel]="false"
    [manageModel]="false"
    [wizChecked]="isPinned()"
    (wizClick)="setPinned($event)"
  ></wiz-checkbox>
  <wiz-icon *ngIf="showPinned()" class="image-inactive">arrow-left</wiz-icon>
  
  
  <wiz-icon #btnConf *ngIf="showSettings" (click)="showConf()" >settings</wiz-icon >
    <wiz-hgroup width="100%">
      <wiz-label [wizLabel]="data.labelOrDefaultLabel" width="100%"></wiz-label>
    </wiz-hgroup>
  <wiz-icon *ngIf="isUsed()" class="image-inactive">icon-see</wiz-icon>
  
  <wiz-icon #iconRemove *ngIf="isInContentList()" (click)="doDelete()">delete</wiz-icon>
</wiz-hgroup>
